/**
 * Nazwy procedur
 *
 * @export
 * @enum {number}
 */
export enum ProcedureCodes {
  OW003Benefit = 'Zasiłek szkolny o charakterze socjalnym',
  OW003Benefit2026 = 'OW003Benefit2026',
  OW003Scholarship = 'Stypendium szkolne o charakterze socjalnym',
  OW003Scholarship2026 = 'OW003Scholarship2026',
  OW003Prezydencki = 'OW-003 - Wniosek o przyznanie wyróżnień dla uczniów',
  OW003PrezydenckiAggregate = 'Wyróżnienie dla uczniów',
  OW004 = 'Dofinansowanie kosztów kształcenia młodocianego pracownika',
  OW004Announcement = 'Zawiadomienie o zatrudnieniu młodocianego pracownika'
}
